<form (validate)="save()" novalidate class="no-margin" validation-es>
  <article class="page-container flex flex-column">
    <section class="col-12 px-0 py-0 align-items-center form__field flex-row">
      <label class="field__label no-margin">{{screen.patient}}</label>
      <div class="inline-flex align-items-center vital-sign__patient-heading-group">
        <button type="button" pButton icon="fas fa-pencil-alt" class="p-button-warning p-button-outlined"
          [pTooltip]="screen.editPatient" (click)="openModal()">
        </button>
        <h3 class="vital-sign__patient-heading">{{patient.fullName}} ({{patient.document}})</h3>
      </div>
    </section>

    <section class="col-12 px-0 py-0 align-items-center form__field flex-row">
      <label class="field__label no-margin">{{screen.bornDate}}</label>
      <span class="vital-sign__patient-heading-group">
        {{patient.dateBorn | date : 'dd-MM-yyyy' : '+0000'}}{{patient.ageLabel}}
      </span>
    </section>

    <hr>

    <section class="col-12 lg:col-10 px-0 py-0 inline-flex flex-column">
      <div class="form__field align-items-center flex-row flex-wrap">
        <label class="col-8 md:col-4 py-0 m-0 justify-content-end align-items-center text-right" for="temperature">
          <span>{{screen.temperature}}</span>
        </label>
        <div class="col-4 md:col-2 pr-0 py-0">
          <input pInputText type="number" name="temperature" [(ngModel)]="header.temperature" class="no-margin"
            validation />
        </div>
        <label class="col-8 md:col-4 py-0 m-0 justify-content-end align-items-center text-right" for="bloodPressure">
          <span>{{screen.bloodPressure}}</span>
        </label>
        <div class="col-4 md:col-2 pr-0 pb-0 pt-2 md:pt-0">
          <p-inputMask name="bloodPressure" [(ngModel)]="header.bloodPressure" mask="999/99?9" class="no-margin"
            validation></p-inputMask>
        </div>
      </div>

      <div class="form__field align-items-center flex-row flex-wrap">
        <label class="col-8 md:col-4 py-0 m-0 justify-content-end align-items-center text-right" for="pulse">
          <span>{{screen.pulse}}</span>
        </label>
        <div class="col-4 md:col-2 pr-0 py-0">
          <input pInputText type="number" name="pulse" [(ngModel)]="header.pulse" class="no-margin" validation />
        </div>
        <label class="col-8 md:col-4 py-0 m-0 justify-content-end align-items-center text-right" for="breathingFrequency">
          <span>{{screen.breathingFrequency}}</span>
        </label>
        <div class="col-4 md:col-2 pr-0 pb-0 pt-2 md:pt-0">
          <input pInputText type="number" name="breathingFrequency" [(ngModel)]="header.breathingFrequency"
            class="no-margin" validation />
        </div>
      </div>

      <div class="form__field align-items-center flex-row flex-wrap">
        <label class="col-8 md:col-4 py-0 m-0 justify-content-end align-items-center text-right" for="weight">
          <span>{{screen.weight}}</span>
        </label>
        <div class="col-4 md:col-2 pr-0 py-0">
          <input pInputText type="number" name="weight" [(ngModel)]="header.weight" class="no-margin" validation />
        </div>
        <label class="col-8 md:col-4 py-0 m-0 justify-content-end align-items-center text-right" for="height">
          <span>{{screen.height}}</span>
        </label>
        <div class="col-4 md:col-2 pr-0 pb-0 pt-2 md:pt-0">
          <input pInputText type="number" name="height" [(ngModel)]="header.height" class="no-margin" validation />
        </div>
      </div>

      <div class="form__field align-items-center flex-row flex-wrap">
        <label class="col-8 md:col-4 py-0 m-0 justify-content-end align-items-center text-right" for="glucose">
          <span>{{screen.glucose}}</span>
        </label>
        <div class="col-4 md:col-2 pr-0 py-0">
          <input pInputText type="number" name="glucose" [(ngModel)]="header.glucose" class="no-margin" validation />
        </div>
        <label class="col-8 md:col-4 py-0 m-0 justify-content-end align-items-center text-right" for="oxygenSaturation">
          <span>{{screen.oxygenSaturation}}</span>
        </label>
        <div class="col-4 md:col-2 pr-0 pb-0 pt-2 md:pt-0">
          <input pInputText type="number" name="oxygenSaturation" [(ngModel)]="header.oxygenSaturation"
            class="no-margin" validation />
        </div>
      </div>

      <div class="form__field align-items-center flex-row flex-wrap">
        <label class="col-8 md:col-10 py-0 m-0 justify-content-end align-items-center text-right" for="headCircumference">
          <span>{{screen.headCircumference}}</span>
        </label>
        <div class="col-4 md:col-2 pr-0 py-0">
          <input pInputText type="number" name="headCircumference" [(ngModel)]="header.headCircumference"
            class="no-margin" validation />
        </div>
      </div>

      <section class="form__field align-self-end">
        <button pButton [type]="loading ? 'button' : 'submit'" [label]="loading ? screen.saving : screen.save"
          [icon]="loading ? loadingIcon : 'far fa-save'" class="p-button-success p-button-outlined"></button>
      </section>
    </section>
  </article>
</form>